import state from './moduleLayoutState'
import actions from './moduleLayoutActions'
import getters from './moduleLayoutGetters'
import mutations from './moduleLayoutMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
